import { useTranslation } from 'react-i18next';

import { OpTextButton } from 'new-components/DLS/OpTextButton/OpTextButton';
import { useAddQueryParams } from 'utils/customHooks/useAddQueryParams';
import { useSelectorJs } from 'utils/customHooks';
import { selectFeatureFlag } from 'global/openpathconfig/selectors';
import { OpInfoTooltip } from 'new-components/DLS/OpInfoTooltip/OpInfoTooltip';

import { avigilonAltaIdTooltipText } from '../LoginSSOAltaIdForm/constants';

import './UseAltaIdButton.scss';

/**
 * @component
 * @description Component used on the LoginSSOEmailForm component to navigate to
 * a different form of login using an Avigilon Alta Id. That will be an uuid provider
 * from their identity provider (currently only used with a samlJit IdP thats associated with out SAML SSO app)
 */
export const UseAltaIdButton = () => {
  const { t } = useTranslation();
  const addQueryParams = useAddQueryParams();
  const enabledFeatureCodes = useSelectorJs(
    selectFeatureFlag('ENABLED_FEATURE_CODES'),
  );

  // Hide behind feature flag for now
  if (
    !enabledFeatureCodes.includes('samlSso') ||
    !enabledFeatureCodes.includes('samlJit')
  ) {
    return null;
  }

  const onClick = () => {
    addQueryParams({ useAltaId: 'true' });
  };

  return (
    <div className="use-alta-id-button">
      <OpTextButton onClick={onClick} className="use-alta-id-button__button">
        {t('Use Avigilon Alta Id')}
      </OpTextButton>
      <OpInfoTooltip
        className="use-alta-id-button__tooltip"
        title={t(avigilonAltaIdTooltipText)}
      />
    </div>
  );
};
